// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { qtyFieldStyles } from "@pace/App/Components/Qty/QtyField";
import cartLineSharedStyles from "@pace/App/SharedStyles/CartLineSharedStyles";
import { savedOrderDetailsCartLineStyles } from "@pace/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { mergeWithCss } from "@pace/XDL/Utilities";
import { css } from "styled-components";

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

savedOrderDetailsCartLineStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

savedOrderDetailsCartLineStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

savedOrderDetailsCartLineStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

savedOrderDetailsCartLineStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

savedOrderDetailsCartLineStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

savedOrderDetailsCartLineStyles.cartLineErrorMessageText = {
    ...cartLineSharedStyles.errorMessage,
};

savedOrderDetailsCartLineStyles.extendedUnitNetPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};
savedOrderDetailsCartLineStyles.cartLineQuantity = {
    readOnlyQuantityText: {
        extendedStyles: {
            heading: {
                ...cartLineSharedStyles.qtyLabel,
            },
            text: {
                ...mergeWithCss(qtyFieldStyles.valueText, {
                    size: 16,
                    weight: "bold",
                    lineHeight: "17px",
                    css: css`
                        padding-top: 6px;
                    `,
                }),
            },
        },
    },
};

savedOrderDetailsCartLineStyles.cartLineContainer = {
    container: {
        css: css`
            grid-template-columns: 91px minmax(0, 267px) minmax(0, 143px) minmax(0, 138px) minmax(0, 111px) minmax(
                    0,
                    135px
                );
        `,
    },
};
